import {
  ELASTIC_CONDITION_MUST,
  ELASTIC_CONDITION_MUST_NOT,
  ELASTIC_CONDITION_SHOULD
} from '@/constants/elastic.constants.js'

/**
 * @typedef FilterService
 */
export const FilterService = () => ({
  prepareAdvancedFilter(filters) {
    if (!filters || Object.keys(filters).length === 0) {
      return undefined
    }

    const preparedFilters = {
      condition: ELASTIC_CONDITION_MUST,
      children: []
    }

    for (const [field, values] of Object.entries(filters)) {
      const group = {
        condition: ELASTIC_CONDITION_MUST,
        children: []
      }

      const groupedRules = this.__prepareGroupedRules(field, values)
      for (const [condition, children] of Object.entries(groupedRules)) {
        if (children.length > 0) {
          group.children.push({
            condition,
            children
          })
        }
      }

      if (group.children.length > 0) {
        preparedFilters.children.push(group)
      }
    }

    if (preparedFilters.children.length > 0) {
      return preparedFilters
    }

    return undefined
  },

  __prepareGroupedRules(field, values) {
    const group = {
      [ELASTIC_CONDITION_MUST]: [],
      [ELASTIC_CONDITION_MUST_NOT]: [],
      [ELASTIC_CONDITION_SHOULD]: []
    }

    values.forEach((value) => {
      const rule = {
        field,
        condition: value.ruleCondition,
        value: value.value
      }

      group[value.condition].push(rule)
    })

    return group
  }
})
